import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Grid from "@material-ui/core/Grid/Grid";
import ComplexGrid from "../../common/ComplexGrid";
import CircularProgress from "@material-ui/core/CircularProgress";
import {renderMilisecondsToTimeDuration} from "../../utils/datetimehelp";


const useStyles = makeStyles(theme => ({

  mainGrid: {
      margin: '6px 0px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'space-around',
      alignItems: 'stretch',
      alignContent: 'stretch'
  },
  marginAuto:{
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0,
     // margin: '8px',
      border: '3px',
      borderColor: 'yellow'
  },
  marginMostLeft:{
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0,
        marginRight: '8px',
        border: '3px',
        borderColor: 'yellow'
  },
    marginMostRigth:{
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0,
        marginLeft: '8px',
        border: '3px',
        borderColor: 'yellow'
    }



}));

const renderLoadingScreen = () => {
    const { classes } = this.props;
    return (
        <React.Fragment>
            {this.renderSearchComponent()}
            <div align="center">
                <CircularProgress className={classes.progress} />
            </div>
        </React.Fragment>
    )
}

export default function AplicacaoBandaKPI(prop) {
  const {dados,  isLoading} = prop;
  const classes = useStyles();


  if (isLoading) {return renderLoadingScreen()}

  return (
    <Grid container className={classes.mainGrid}>

          {dados.totais.map( (e,ix) => {
             return (
              <Grid container item key={ix} xs={12} lg={12} className={classNames(classes.marginAuto)}>
                  <Grid item xs={6} lg={6} className={classNames(classes.marginMostLeft)}>
                      <ComplexGrid
                      key={ix}
                      className={classes.marginMostLeft}
                      leftSideGrid={true}
                      iconState="success"
                      icon="business_money-coins"
                      mainvalue={<span><small></small>
                          {e.quantidade}</span>}
                      title={<span>PRODUÇÃO PLANTA {e.estabelecimentoId}</span>}
                      description={<span>ordens serviço aplicadas.</span>}
                      unit="un"
                  />
                  </Grid>
                  <Grid item   xs={6} lg={6} className={classNames(classes.marginMostRigth)}>
                      <ComplexGrid
                          key={ix}
                          className={classes.marginMostRigth}
                          leftSideGrid={true}
                          iconState="success"
                          icon="business_money-coins"
                          mainvalue={<span><small></small>
                              {renderMilisecondsToTimeDuration(Math.floor(e.tempo) * 1000)}</span>}
                          title={<span>TEMPO MEDIO {e.estabelecimentoId}</span>}
                          description={<span>por ordem de serviço.</span>}
                          unit="un"
                      />
                  </Grid>
             </Grid>)

          })}

    </Grid>
  )
}
;
